// removed by extract-text-webpack-plugin
module.exports = {"component":"_1gjxDV8LMJ0M5mOG0RoP82"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Cart/Templates/Mobile/theme.css
// module id = 1247
// module chunks = 2